import { render, staticRenderFns } from "./ProjectStats.vue?vue&type=template&id=6107a014&scoped=true&"
import script from "./ProjectStats.vue?vue&type=script&lang=js&"
export * from "./ProjectStats.vue?vue&type=script&lang=js&"
import style0 from "./ProjectStats.vue?vue&type=style&index=0&id=6107a014&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6107a014",
  null
  
)

export default component.exports